import { SET_AUCTION_ITEM, SET_SERVER_TIME } from './types'

export default {
   [SET_AUCTION_ITEM] (state, payload) {
        state.auctionItem = payload
   },
   [SET_SERVER_TIME] (state, payload) {
      state.serverTime = payload
 }
}